import { useContext } from 'react'
import { TwoFAContext } from 'contexts/twoFAContext'

export const useTwoFAContext = () => {
  return useContext(TwoFAContext)
}
